import { createFileRoute, Outlet } from '@tanstack/react-router'
import { protectedRouteGuard } from '@/utils/routeGuards'
import { serversApi } from '@/features/Servers/infrastructure/api'

export const Route = createFileRoute('/infra/servers/$id')({
  loader: async ({ params }) => {
    const server = await serversApi.getServerById(params.id)
    return {
      crumb: server.name || server.id,
    }
  },
  beforeLoad: protectedRouteGuard,
  component: () => <Outlet />,
})
